export default __webpack_public_path__ + "static/jamil-80587b1cfbb41dd8ae5a79b3a58a7fe8.png";